import SdgGoal from "@/components/SdgGoal/SdgGoal";
import { SdgGoalResult } from "@/schema/console/evaluation-reports/SdgGoalResult";

interface AchievementItemProps {
  sdgGoalResult: SdgGoalResult;
}

function AchievementItem({
  sdgGoalResult: { sdg_goal_id, name, score },
}: AchievementItemProps) {
  return (
    <div className=" flex flex-row space-x-2 min-w-[180px]">
      <SdgGoal goal={sdg_goal_id} />
      <div className=" flex flex-col space-y-1">
        <p className=" text-sm font-normal text-cool-gray-600">{name}</p>
        <p className=" text-2xl font-medium text-cool-gray-700">
          {score ? score : "--"}
        </p>
      </div>
    </div>
  );
}

export default AchievementItem;
